import {Event} from 'main.core';

export class BaseDetailSlider extends Event.EventEmitter {
    constructor(sliderBlock, params) {
        super();
        this.sliderBlock = sliderBlock;
        this.imagesSets = null;

        this.setEventNamespace('BX.Asteq.Slider');

        this.mainSwiper = null;
        this.mainSwiperBlock = null;
        this.mainSwiperSlideTemplate = null;

        this.thumbsSwiper = null;
        this.thumbsSwiperBlock = null;
        this.thumbsSwiperSlideTemplate = null;

        this.initBlocks();
        this.initSwipers();
        this.initEvents();
    }

    getId() {
        if (!this.sliderBlock) {
            return null;
        }
        return this.sliderBlock.id;
    }

    initBlocks() {
        if (!this.sliderBlock) {
            return;
        }

        const mainSwiperBlock =
            this.sliderBlock.hasAttribute('data-main-swiper')
                ? this.sliderBlock
                : this.sliderBlock.querySelector('[data-main-swiper]');

        if (mainSwiperBlock) {
            this.mainSwiperBlock = mainSwiperBlock;
        }

        const thumbsSwiperBlock = this.sliderBlock.querySelector('[data-thumbs-swiper]');
        if (thumbsSwiperBlock) {
            this.thumbsSwiperBlock = thumbsSwiperBlock;
        }
    }

    initSwipers() {
        console.error('Необходимо переопределить метод инифиализации слайдеров');
    }

    initEvents() {
        const id = this.getId();
        if (!id) {
            return;
        }

        Event.EventEmitter.subscribe('BX.Asteq.Slider-' + id + ':setImages', this.onSetImages.bind(this));
        Event.EventEmitter.subscribe('BX.Asteq.Slider-' + id + ':setImagesSets', this.onSetImagesSets.bind(this));
    }

    setSwiperImages(images, swiper, slideTemplate) {
        const newImages = [];
        let newImagesStr = '';
        images.forEach((image) => {
            const slide = slideTemplate.cloneNode(true);
            const imgEl = slide.tagName === 'IMG' ? slide : slide.querySelector('img');
            if (!imgEl) {
                return;
            }

            imgEl.src = image.SRC;
            imgEl.width = image.WIDTH;
            imgEl.height = image.HEIGHT;
            newImages.push(slide);
            newImagesStr += slide.outerHTML;
        });

        const wrapper = swiper.wrapperEl;
        wrapper.innerHTML = newImagesStr;
        // newImages.forEach((img) => {
        //     wrapper.appendChild(img);
        // });
        swiper.updateSlides();
        swiper.setTranslate(0);
        swiper.slideTo(0);
    }

    setSlidesImages(images) {
        if (!images) {
            return;
        }

        if (!this.mainSwiper) {
            console.error('Не найден основной свайпер');
            return;
        }

        if (!this.mainSwiperSlideTemplate) {
            console.error('Не найден шаблон слайда основного свайпера');
            return;
        }

        this.setSwiperImages(images, this.mainSwiper, this.mainSwiperSlideTemplate);

        if(this.mainSwiper?.thumbs) {
            this.mainSwiper.thumbs.update();
        }
    }

    setThumbImages(images) {
        if (!images) {
            return;
        }

        if (!this.thumbsSwiper) {
            // console.error('Не найден слайдер пагинации');
            return;
        }

        if (!this.thumbsSwiperSlideTemplate) {
            console.error('Не найден шаблон слайда пагинации');
            return;
        }

        this.setSwiperImages(images, this.thumbsSwiper, this.thumbsSwiperSlideTemplate);
    }

    setImages(imagesSets) {
        this.setThumbImages(imagesSets.thumbs);
        this.setSlidesImages(imagesSets.slides);
        this.imagesSets = imagesSets;

        this.emit('afterSetImages');
    }

    onSetImages(event) {
        const data = event.getData();
        if (!data || !data.images) {
            return;
        }

        this.setImages(data.images);
    }

    onSetImagesSets(e) {
        const imagesSets = e.getData().images;
        if (!imagesSets) {
            return;
        }

        this.imagesSets = imagesSets;
    }
}